import type OwaUserConfiguration from '../contract/OwaUserConfiguration';
import type OwaViewStateConfiguration from '../contract/OwaViewStateConfiguration';
import type SessionSettingsType from '../contract/SessionSettingsType';
import type UserOptionsType from '../contract/UserOptionsType';
import type RecursiveReadOnly from '../RecursiveReadOnly';
import type {
    AccountScopeOwaUserConfigurationKeys,
    AccountScopeUserOptionsKeys,
    AccountScopeViewStateConfigurationKeys,
    AccountScopeSessionSettingsKeys,
} from './AccountScopeUserSettings';

export const deletedUserConfigurationSessionSettingsProperties = [
    'DefaultFolderIds',
    'DefaultFolderNames',
] as const;

export type deletedUserConfigurationSessionSettingsKeys = typeof deletedUserConfigurationSessionSettingsProperties[number];

// These are properties in OwaUserConfiguration that we want to replace with something we define here.
type TransformedSubproperties = {
    SessionSettings?: Omit<
        SessionSettingsType,
        deletedUserConfigurationSessionSettingsKeys | AccountScopeSessionSettingsKeys
    >;
    UserOptions?: Omit<UserOptionsType, AccountScopeUserOptionsKeys>;
    ViewStateConfiguration?: Omit<
        OwaViewStateConfiguration,
        AccountScopeViewStateConfigurationKeys
    >;
};

// This is the base type that session store clients will see and use instead of OwaUserConfiguration.
export type SessionUserConfiguration = Omit<
    OwaUserConfiguration,
    AccountScopeOwaUserConfigurationKeys | keyof TransformedSubproperties
> &
    TransformedSubproperties;

// And its readonly variant. This is also the observable form returned from getUserConfiguration() and has several
// properties suppressed for observability perf.
export type ReadOnlySessionUserConfiguration = RecursiveReadOnly<
    Omit<SessionUserConfiguration, 'Favorites' | 'SmimeAdminSettings'>
>;
